import { ActionMenu } from 'components/ActionStyles/ActionStyles'
import RightArrow from 'components/icons/RightArrow'
import {
  CandCount,
  CardSectionFlex,
  CardText,
  CardsDiv,
  CardsFlex,
  CardsRowFlex,
  CardsValue,
  RoleFlex,
  RoleNumber,
  RoleTitle,
} from 'modules/Drives/ViewDriveRole/Style/style'
import React from 'react'
import { COLORS } from 'theme'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

export const roleMenu = (onRoleChange, roleMenu = []) => (
  <ActionMenu
    width="335px"
    items={
      Array.isArray(roleMenu)
        ? roleMenu?.map((role, index) => {
            return {
              key: index,
              label: (
                <RoleFlex
                  row
                  spaceBetween
                  centerVertically
                  onClick={() => onRoleChange(role?.roleId)}
                >
                  <RoleFlex column>
                    <RoleNumber>Role {getZeroBeforeInt(index + 1)}</RoleNumber>
                    <RoleTitle>{role?.roleName}</RoleTitle>
                  </RoleFlex>
                  <CandCount>
                    {getZeroBeforeInt(role?.candidateCount)}
                  </CandCount>{' '}
                </RoleFlex>
              ),
            }
          })
        : Object.keys(roleMenu)
    }
  />
)
function isObject(value) {
  return typeof value === 'object' && value !== null
}
const DriveRoleMetrics = ({
  rolesMetrics,
  selectedRound,
  setSelectedRound,
  setSearchParams,
  setCurrentPage,
  setSelectedCandidateId,
  setSelectedCandidate,
  setCurrentTab,
  setStatus,
  setFilterStatus,
  setType,
  setCurrentScoreTab,
  setScoreStatus,

  setSearchValue,
  setCurrentScorePage,
  setSearchScoreValue,
  setPanelData,
  setPanelValue,
  setScorePayload,
}) => {
  const onClickRound = (round, type, assessment, extAssmnts) => {
    setCurrentPage(0)
    setSelectedCandidateId([])
    setSelectedCandidate([])
    setCurrentTab('ACTIVE')
    setStatus('ACTIVE')
    setFilterStatus('ACTIVE')
    setSelectedRound(round)
    setSearchParams({
      stage: round,
      type: type || 'all',
      assessment: assessment || 'Test Gorilla',
      isUpload: isObject(extAssmnts),
      assessmentId: extAssmnts?.id,
      isBack: false,
    })
    setType({ type: type, assessmentType: assessment })
    setCurrentScoreTab('INVITED,STARTED,COMPLETED,ABSENT')
    setScoreStatus('INVITED,STARTED,COMPLETED,ABSENT')
    setSearchValue('')
    setCurrentScorePage(0)
    setSearchScoreValue('')
    setPanelData('')
    setPanelValue('all')
    setScorePayload({})
  }

  return (
    <div>
      <CardsRowFlex row wrap>
        <CardsDiv>
          <CardsFlex
            column
            onClick={() => onClickRound('all_candidates')}
            isSelected={selectedRound === 'all_candidates'}
          >
            <CardText>All Candidates</CardText>
            <CardsValue>
              {getZeroBeforeInt(rolesMetrics[0]?.candidateCount)}
            </CardsValue>
          </CardsFlex>
        </CardsDiv>

        {rolesMetrics[0]?.rounds?.map((round, index) => (
          <CardSectionFlex key={index + round?.roundName} centerVertically>
            <CardsFlex
              column
              onClick={() =>
                onClickRound(
                  round?.roundName,
                  round?.type,
                  round?.assesmentType,
                  round?.extAssmnts
                )
              }
              isSelected={selectedRound === round?.roundName}
            >
              <CardText>
                {round?.roundName == 'offer'
                  ? 'Intent to Offer'
                  : round?.roundName}
              </CardText>
              <CardsValue>{getZeroBeforeInt(round?.count)}</CardsValue>
            </CardsFlex>
            {rolesMetrics[0]?.rounds?.length - 1 !== index && (
              <RightArrow color={COLORS.GREY_T_80} />
            )}
          </CardSectionFlex>
        ))}
      </CardsRowFlex>
    </div>
  )
}

export default DriveRoleMetrics
